import {Component, ElementRef} from "@angular/core";
import {NgForm} from "@angular/forms";
const $ = require('jquery');

@Component({
    selector: 'form-submitter', template: '<ng-content></ng-content>'
})
export class FormSubmitter {

    private rootEl: any;
    private triggerEl: any;

    constructor(private form: NgForm, private el: ElementRef) {
    }

    ngOnInit() {
        this.rootEl = $(this.el.nativeElement);
        this.triggerEl = this.rootEl.find('[type="submit"]');
    }

    submit() {
        this.triggerEl.trigger('click');
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/form/form.submitter.ts